import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSketchComponent } from './simple-icons-sketch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSketchComponent ],
    exports:      [ SimpleIconsSketchComponent ],
    bootstrap:    []
})
export class SimpleIconsSketchModule {}
